// init all on page
const swipers = new Map();

jQuery(function($) {

  if ($('.bundle-button').length) {
    $('.bundle-button').on('click', function() {
      const bundleTitle = $(this).prev().text().trim().toLowerCase().replace(/<br\s*\/?>/gi, '').replace(/[\s,&]+/g, '-');
      const bundleGender = $('.jci-bundle-tabs .bundle-tab.active').attr('data-tab');

      const bundleKey = $(this).data('bundle-key');

      window.location.href = `?bundle=${bundleKey}&gender=${bundleGender}`;
    });
  }

  const selector = $('.jci-bundle-selector');
  if (!selector.length) return;

  const reqA = parseInt(selector.data('requiredGroupA'),10);
  const reqB = parseInt(selector.data('requiredGroupB'),10);
  const reqC = parseInt(selector.data('requiredGroupC'),10);
  function requiredFor(tab) {
    return tab==='group-a'?reqA
         : tab==='group-b'?reqB
         : tab==='group-c'?reqC
         : 0;
  }

  let currentTabEl  = $('.jci-bundle-tab.active');
  let currentTab  = currentTabEl.data('tab');
  let currentReq  = requiredFor(currentTab);
  let currentProd = null;
  let currentPrice  = 0;
  const selectedItems = {};

  $('.jci-bb-required').text(currentReq);
  $('.jci-bb-product-type').text($('.jci-bundle-tab.active').text());

  async function getCart() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(`${root}cart.js`, {
      method: 'GET',
      headers: { Accept: 'application/json' }
    });
    if (!res.ok) throw new Error(`Cart fetch failed: ${res.status}`);
    return res.json();
  }

  function updateIndicator(count) {
    const $ind = $('.jci-bundle-indicator').empty();
    for (let i = 1; i <= currentReq; i++) {
      $ind.append(
        $('<span>')
          .addClass('indicator-circle')
          .toggleClass('filled', i <= count)
      );
    }
  }

  function renderSelectedList() {
    const $list = $('.jci-selected-list').empty();
    selectedItems[currentTab]?.items?.forEach((it,i) => {
      $list.append(`
        <div class="selected-item" data-index="${i}">
          <img src="${it.image}" />
          <button class="remove-item">×</button>
        </div>
      `);

      const $tmp = selector.find(`.jci-bundle-item[data-product-handle="${it.handle}"]`)[0];
      setTimeout(() => {
        $tmp?.classList?.add('selected');
      }, 10);
    });
  }

  function allTabsComplete() {
    const tabs = ['group-a', 'group-b', 'group-c'];
    for (const tab of tabs) {
      const req = requiredFor(tab);
      if ($(`.${tab}-grid`).length === 0) continue;
      const items = selectedItems[tab]?.items?.length || 0;
      if (items !== req) return false;
    }
    return true;
  }

  function refreshUI() {
    const count = selectedItems[currentTab]?.items?.length ?? 0;
    $('.jci-bb-counter').text(count);
    updateIndicator(count);

    if(selectedItems[currentTab]?.items?.length==requiredFor(currentTab)){
      $('.jci-bb-confirm-button').html("Go to next step");
    }else{
      $('.jci-bb-confirm-button').html("Confirm Selection");
    }

    const isFull = allTabsComplete();
    $('.jci-bb-confirm-button').toggle(!isFull);
    $('.jci-proceed-checkout').toggle(isFull);
    updateSavings();
    updateTotalPrice();
    setTimeout(() => {
      updateSlider();
    }, 100);

    $('.jci-sizing-chart-wrapper button[data-drawer-opener]').attr("data-drawer-opener", `SizeChart-${currentProd?.id}`);
  }

  function updateSlider(){
    swipers.forEach(sw => sw.update());
  }

  function updateSavings() {
    const key         = currentTab.split('-')[1];          // "a", "b", or "c"
    const bundlePrice = parseFloat(selector.data(`price-${key}`));
    const count       = selectedItems[currentTab]?.items?.length ?? 0;
    // sum of all original prices in dollars
    const sum         = selectedItems[currentTab]?.items?.reduce((sum, it) => sum + it.price/100, 0) ?? 0;
    // “you’d pay” at bundle rate = bundlePrice/required * count
    const paid        = bundlePrice / requiredFor(currentTab) * count;
    const savings     = (sum - paid).toFixed(2);
    $('.savings-wrapper span').text(savings);
  }

  function updateOfferPrice() {
    // grab “a”, “b” or “c” from “group-a” etc.
    const key   = currentTab.split('-')[1];
    // read the bundle price from your data-price-a/b/c attrs
    const price = parseFloat(selector.data(`price-${key}`)).toFixed(2);
    // update the H5 text
    $('.offer-price').text(`Offer Price: $${price}`);
  }

  $('.jci-bundle-tab').off('click').on('click', function() {


    const $tabs = $('.jci-bundle-tab');
    const clickedIndex = $tabs.index($(this));
    const currentIndex = $tabs.index(currentTabEl);

    // don't exceed the required number
    const nextTab = $(this).text();
    const currentTabText = currentTabEl.text();
    const currentItems = selectedItems[currentTab]?.items?.length || 0;

    if (clickedIndex > currentIndex) {
      // enforce required selection for current tab
      if (currentItems !== currentReq) {
        alert(`Please complete the required ${currentReq} selections in ${currentTabText.toUpperCase()} before moving to ${nextTab.toUpperCase()}.`);
        return;
      }
    }

    currentTabEl = $(this);
    currentTab   = $(this).data('tab');
    currentReq   = requiredFor(currentTab);
    $('.jci-bb-required').text(currentReq);
    $('.jci-bb-product-type').text($(this).text());

    $('.jci-bundle-tab, .jci-bundle-grid').removeClass('active');
    $(this).addClass('active');
    $('.' + currentTab + '-grid').addClass('active');

    //selectedItems.length = 0;
    renderSelectedList();
    selector.find('.jci-bundle-item.selected, .jci-temp-active')
            .removeClass('selected jci-temp-active');

    // pick & temp‐activate the first item
    const first = $(`.${currentTab}-grid .jci-bundle-item`).first();
    selector.find('.jci-temp-active').removeClass('jci-temp-active');
    first.addClass('jci-temp-active');

    if (first.length) {
      loadBundleDetail(first.data('product-handle'));
    }

    refreshUI();
    updateOfferPrice();
  });

  selector.on('click', '.jci-bundle-item', function() {
    const $item = $(this);
    const isConfirmed = $item.hasClass('selected');
    // Prevent temp‐selecting any new item once we're at the limit
    if (!isConfirmed && selectedItems[currentTab]?.items?.length >= currentReq) return;

    selector.find('.jci-temp-active').removeClass('jci-temp-active');
    $item.addClass('jci-temp-active');
    loadBundleDetail($item.data('product-handle'));
    refreshUI();
  });

  $('.jci-bb-confirm-button').off('click').on('click', function() {
    if($(this).text()=="Go to next step"){
      let nextTabEl    = currentTabEl.next('.jci-bundle-tab');
      return nextTabEl.click();
    }
    // don't exceed the required number
    if (selectedItems[currentTab]?.items?.length >= currentReq) return;

    const key         = currentTab.split('-')[1];
    const bundlePrice = parseFloat(selector.data(`price-${key}`));

    if(!selectedItems[currentTab]){
      selectedItems[currentTab] = {
        bundlePrice: bundlePrice,
        is_bundle: true,
        items: [],
      };
    }

    const $tmp = selector.find('.jci-temp-active');
    if (!$tmp.length) return;

    const size = $('#bundle-detail-size-pickers input[name="bundle-size"]:checked').val();
    const variant = currentProd.variants.find(v => v.option1 === size) || currentProd.variants[0];
    selectedItems[currentTab]?.items?.push({
      handle:    currentProd.handle,
      size,
      variantId: variant.id,
      image:     $tmp.find('img').attr('src'),
      price:     currentPrice,
    });

    $tmp.removeClass('jci-temp-active').addClass('selected');
    renderSelectedList();
    refreshUI();
  });

  $('.jci-selected-list').on('click', '.remove-item', function() {
    const idx = $(this).closest('.selected-item').data('index');
    const removed = selectedItems[currentTab]?.items?.splice(idx, 1)[0];
    selector
      .find(`.jci-bundle-item[data-product-handle="${removed.handle}"]`)
      .removeClass('selected');
    renderSelectedList();
    refreshUI();
  });

  function updateTotalPrice() {
    const total = selectedItems[currentTab]?.items?.reduce((sum, it) => sum + it.price/100, 0)
      .toFixed(2) ?? 0;
    $('.products-price s').text(`$${total}`);
  }

  function loadBundleDetail(handle) {
    fetch(`/products/${handle}.js`)
      .then(r => r.json())
      .then(prod => {
        currentProd = prod;

        // Update “View Product” link
        $('#bundle-selected-product-link').attr('href', location.origin + prod.url);
        $('#bundle-selected-product-link h2').text(prod.title);
        $('#bundle-selected-product-desc').html(prod.description);

        // Show per-item price
        const priceVar      = prod.variants.find(v => v.available) || prod.variants[0];
        currentPrice = priceVar.price;
        const formattedPrice = (priceVar.price / 100).toFixed(2);
        $('.jci-bundle-each-product-price span')
          .text(formattedPrice);

        // Render size pickers
        const opt = prod.options.find(o => o.name.toLowerCase() === 'size');
        if (opt) {
          const html = opt.values.map((v,i) => `
            <input type="radio" id="bundle-size-${i}" name="bundle-size" value="${v}">
            <label for="bundle-size-${i}">${v}</label>
          `).join('');
          $('#bundle-detail-size-pickers').html(html)
            .find('input[name="bundle-size"]').first().prop('checked', true);

          // Show & point the size-chart link
          $('.jci-whats-my-size-link')
            .attr('data-drawer-opener', 'SizeChart-' + prod.id)
            .show();
        } else {
          $('#bundle-detail-size-pickers').empty();
          $('.jci-whats-my-size-link').hide();
        }
      })
      .catch(console.error);
  }

  const first = selector.find('.jci-bundle-grid.active .jci-bundle-item').first();
  if (first.length) first.click();
  refreshUI();

  // Interacts with custom Node.js endpoint
  $('.jci-proceed-checkout').off('click').on('click', async function() {
    const $btn    = $(this);
    const $loader = $btn.find('.loader');
    const $text   = $btn.find('.button-text');
    $loader.show();
    $text.text('Processing...');
    $btn.prop('disabled', true);

    const key         = currentTab.split('-')[1];
    const bundlePrice = parseFloat(selector.data(`price-${key}`));

    try {
      try {
        let getCartItems = await getCart();
        selectedItems['_cart'] = {
          is_bundle: false,
          bundlePrice: 0,
          items: getCartItems.items.map((v) => {
            return {
              handle: v.handle,
              image: v.image,
              price: v.price,
              variantId: v.variant_id,
              quantity: v.quantity,
            };
          })
        };
      } catch (error) {
        console.log("no item on cart!")
      }

      const resp = await fetch('https://cycology-endpoint.vercel.app/api/checkout', {
      //const resp = await fetch('http://localhost:3000/api/checkout', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ selectedItems: selectedItems })
      });
      const json = await resp.json();
      if (!resp.ok) throw new Error(json.error || 'Unknown error');
      window.location.href = json.checkoutUrl;
    } catch (err) {
      console.error('Checkout failed:', err);
      alert('Sorry, there was a problem creating your bundle. Please try again.');
      $loader.hide();
      $text.text('Proceed to Checkout');
      $btn.prop('disabled', false);
    }
  });

});

function createSwiper(el) {
  const LIMITER = 400;
  return new Swiper(el, {
    slidesPerView: 3,
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-btn.next",
      prevEl: ".swiper-btn.prev",
    },
    grid: {
      rows: 3,
      fill: 'row',
    },
    breakpoints: {
      // Mobile (≤768px)
      0: {
        direction: "vertical",
        slidesPerView: 2,
        spaceBetween: 10,
        grid: { rows: 2, fill: 'column' },
      },
      // Tablet and up (≥769px)
      769: {
        slidesPerView: 3,
        spaceBetween: 20,
        grid: {
          rows: 3,
        },
      }
    },
    on: {
      setTranslate(s, t) {
        const LIMIT = -el.querySelector(`.swiper-wrapper`).scrollHeight + LIMITER;
        // live clamp during drag/inertia
        if (window.innerWidth <= 768 && t < LIMIT) {
          s.setTranslate(LIMIT);
        }
      },
      touchEnd(s) {
        const LIMIT = -el.querySelector(`.swiper-wrapper`).scrollHeight + LIMITER;
        // ensure momentum can't overshoot past LIMIT
        if (window.innerWidth <= 768 && s.translate < LIMIT) {
          s.setTransition(200);
          s.setTranslate(LIMIT);
          s.updateProgress(LIMIT);
          s.updateActiveIndex();
          s.updateSlidesClasses();
          s.transitionStart();
          s.transitionEnd();
        }
      },
      // Optional: keep clamped after resize/update
      resize(s) {
        const LIMIT = -el.querySelector(`.swiper-wrapper`).scrollHeight + LIMITER;
        if (window.innerWidth <= 768 && s.translate < LIMIT) s.setTranslate(LIMIT);
      },
      update(s) {
        const LIMIT = -el.querySelector(`.swiper-wrapper`).scrollHeight + LIMITER;
        if (window.innerWidth <= 768 && s.translate < LIMIT) s.setTranslate(LIMIT);
      }


      /*
      touchStart(swiper, e) {
        swiper._startX = e.touches ? e.touches[0].clientX : e.clientX;
        swiper._startY = e.touches ? e.touches[0].clientY : e.clientY;
      },
      touchEnd(swiper, e) {
        // ✅ Apply only on a specific breakpoint
        if (window.innerWidth <= 768) {   // <= mobile breakpoint
          const endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
          const endY = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;

          const diffX = Math.abs(endX - swiper._startX);
          const diffY = Math.abs(endY - swiper._startY);

          const distance = swiper.params.direction === "vertical" ? diffY : diffX;
          console.log(distance)

          if (distance < 40) {
            swiper.slideTo(swiper.activeIndex, 0); // rollback instantly
          }
        }
      }
        */

    }
  });
}

// swiper slider for bundle product grid
(function() {
  document.querySelectorAll('.jci-bundle-swiper').forEach(function(el) {
    const s = createSwiper(el);
    swipers.set(el.id || el, s);
  });

  const mq = window.matchMedia("(max-width: 768px)");

  mq.addEventListener("change", e => {
    setTimeout(() =>{
      if (e.matches) {
        swipers.forEach(sw => sw.update());
      } else {
        swipers.forEach(sw => sw.update());
      }
    }, 2000)
  });

  if (mq.matches) {
    swipers.forEach(sw => sw.update());
  }

})();
